/**
 * Money helpers.
 *
 * The API returns monetary Decimal values as STRINGS (e.g. "100.00"). The
 * danger is `+`: `"100" + 5` concatenates to "1005" instead of adding. (TS
 * can't catch this — `string + number` is legal and yields a string — so the
 * guard is a convention, not a type.) Always run monetary values through
 * `toNumber` before any `+`, and prefer `sumMoney` for reductions.
 */

/**
 * Coerce a possibly-string monetary value to a number. null/undefined/""/NaN
 * all become 0.
 */
export function toNumber(value: string | number | null | undefined): number {
  if (value === null || value === undefined) return 0;
  const num = typeof value === "string" ? parseFloat(value) : Number(value);
  return Number.isNaN(num) ? 0 : num;
}

/**
 * Sum a list of monetary values (strings or numbers) safely as numbers.
 * Use instead of `arr.reduce((s, x) => s + x.amount, 0)` which concatenates
 * when amount is a string.
 */
export function sumMoney(
  values: Array<string | number | null | undefined>
): number {
  return values.reduce<number>((acc, v) => acc + toNumber(v), 0);
}
